module.exports = [{"type":"title","text":"2024-10-16"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"永續U本位Websocket服務：新增‘增量深度推送’功能"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/changelog/2024-10-16.json
// module id = UDLl
// module chunks = 3